import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { UsersubscriptionsApiService } from '../../../projects/api/src/usersubscription/usersubscriptions-api.service';
import { CompaniesResolver } from './profile/company.resolver';
import {ProfileComponent} from './profile/profile.component';
import {ProfileResolver} from './profile/profile.resolver';

export const profilePath = 'profile';

const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: profilePath},
  {
    path: profilePath, component: ProfileComponent, resolve: {
      // company: CurrentCompanyResolver,
      companies: CompaniesResolver,
      profile: ProfileResolver,
      usersubscriptions: UsersubscriptionsApiService,
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [UsersubscriptionsApiService]
})
export class UserRoutingModule {
}
